import { gql } from '@apollo/client';

export const ARCHIVE_WORKSPACE = gql`
  mutation archiveWorkspace($id: ID!) {
    programme: archiveWorkspace(id: $id) {
      id
      name
    }
  }
`;
